export type AppEnv =
  | 'development'
  | 'testing'
  | 'testing2'
  | 'testing3'
  | 'beta'
  | 'production'
  | 'local';

const APP_ENV: AppEnv = (() => {
  if (process.env.REACT_APP_ENV) return process.env.REACT_APP_ENV as AppEnv;

  const { origin } = window.location;
  const envLabels: AppEnv[] = [
    'development',
    'testing3',
    'testing2',
    'testing',
    'beta',
    'production',
  ];
  const envURLs = ['dev', 'testapp3', 'testapp2', 'testapp', 'app2', 'app'];

  for (let index = 0; index < envURLs.length; index += 1) {
    if (origin.includes(envURLs[index])) {
      return envLabels[index];
    }
  }

  return 'production';
})();

const ENV = {
  development: {
    WEB_SERVICE_BASE_URI: process.env.REACT_APP_WEB_SERVICE_BASE_URI_DEV,
    WEB_SERVICE_BROADCAST_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_BROADCAST_BASE_URI_DEV,
    WEB_SERVICE_ECOMMERCE_URI:
      process.env.REACT_APP_WEB_SERVICE_ECOMMERCE_URI_DEV,
    META_APP_ID: process.env.REACT_APP_META_APP_ID_DEV,
    META_ES_CONFIG_ID: process.env.REACT_APP_META_ES_CONFIG_ID_DEV,
    WEB_SERVICE_CONTACTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CONTACTS_BASE_URI_DEV,
    WEB_SERVICE_ASSISTANTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_ASSISTANTS_BASE_URI_DEV,
    WEB_SERVICE_CALLING_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CALLING_BASE_URI_DEV,
    WEB_SERVICE_CATALOG_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CATALOG_BASE_URI_DEV,
    WEB_SERVICE_MERCADOPAGO_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_MERCADOPAGO_BASE_URI_DEV,
    WS_MEDIA_SERVER_BASE_URI:
      process.env.REACT_APP_WS_MEDIA_SERVER_BASE_URI_DEV,
    WS_MEDIA_SERVER_TOKEN: process.env.REACT_APP_WS_MEDIA_SERVER_TOKEN_DEV,
    HUBSPOT_URL: process.env.REACT_APP_HUBSPOT_URL_DEV,
    FUNNEL_TRACKING_BASE_URI:
      process.env.REACT_APP_FUNNEL_TRACKING_BASE_URI_DEV,
    FUNNEL_TRACKING_API_KEY: process.env.REACT_APP_FUNNEL_TRACKING_API_KEY_DEV,
  },
  testing: {
    WEB_SERVICE_BASE_URI: process.env.REACT_APP_WEB_SERVICE_BASE_URI_TEST,
    WEB_SERVICE_BROADCAST_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_BROADCAST_BASE_URI_TEST,
    WEB_SERVICE_ECOMMERCE_URI:
      process.env.REACT_APP_WEB_SERVICE_ECOMMERCE_URI_TEST,
    META_APP_ID: process.env.REACT_APP_META_APP_ID_TEST,
    META_ES_CONFIG_ID: process.env.REACT_APP_META_ES_CONFIG_ID_TEST,
    WEB_SERVICE_CONTACTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CONTACTS_BASE_URI_TEST,
    WEB_SERVICE_ASSISTANTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_ASSISTANTS_BASE_URI_TEST,
    WEB_SERVICE_CALLING_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CALLING_BASE_URI_TEST,
    WEB_SERVICE_CATALOG_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CATALOG_BASE_URI_TEST,
    WEB_SERVICE_MERCADOPAGO_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_MERCADOPAGO_BASE_URI_TEST,
    WS_MEDIA_SERVER_BASE_URI:
      process.env.REACT_APP_WS_MEDIA_SERVER_BASE_URI_DEV,
    WS_MEDIA_SERVER_TOKEN: process.env.REACT_APP_WS_MEDIA_SERVER_TOKEN_DEV,
    HUBSPOT_URL: process.env.REACT_APP_HUBSPOT_URL_TEST,
    FUNNEL_TRACKING_BASE_URI:
      process.env.REACT_APP_FUNNEL_TRACKING_BASE_URI_TEST,
    FUNNEL_TRACKING_API_KEY: process.env.REACT_APP_FUNNEL_TRACKING_API_KEY_TEST,
  },
  testing2: {
    WEB_SERVICE_BASE_URI: process.env.REACT_APP_WEB_SERVICE_BASE_URI_TEST2,
    WEB_SERVICE_BROADCAST_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_BROADCAST_BASE_URI_TEST2,
    WEB_SERVICE_ECOMMERCE_URI:
      process.env.REACT_APP_WEB_SERVICE_ECOMMERCE_URI_TEST2,
    META_APP_ID: process.env.REACT_APP_META_APP_ID_TEST2,
    META_ES_CONFIG_ID: process.env.REACT_APP_META_ES_CONFIG_ID_TEST2,
    WEB_SERVICE_CONTACTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CONTACTS_BASE_URI_TEST2,
    WEB_SERVICE_ASSISTANTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_ASSISTANTS_BASE_URI_TEST2,
    WEB_SERVICE_CALLING_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CALLING_BASE_URI_TEST2,
    WEB_SERVICE_CATALOG_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CATALOG_BASE_URI_TEST2,
    WEB_SERVICE_MERCADOPAGO_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_MERCADOPAGO_BASE_URI_TEST2,
    WS_MEDIA_SERVER_BASE_URI:
      process.env.REACT_APP_WS_MEDIA_SERVER_BASE_URI_DEV,
    WS_MEDIA_SERVER_TOKEN: process.env.REACT_APP_WS_MEDIA_SERVER_TOKEN_DEV,
    HUBSPOT_URL: process.env.REACT_APP_HUBSPOT_URL_TEST2,
    FUNNEL_TRACKING_BASE_URI:
      process.env.REACT_APP_FUNNEL_TRACKING_BASE_URI_TEST2,
    FUNNEL_TRACKING_API_KEY:
      process.env.REACT_APP_FUNNEL_TRACKING_API_KEY_TEST2,
  },
  testing3: {
    WEB_SERVICE_BASE_URI: process.env.REACT_APP_WEB_SERVICE_BASE_URI_TEST3,
    WEB_SERVICE_BROADCAST_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_BROADCAST_BASE_URI_TEST3,
    WEB_SERVICE_ECOMMERCE_URI:
      process.env.REACT_APP_WEB_SERVICE_ECOMMERCE_URI_TEST3,
    META_APP_ID: process.env.REACT_APP_META_APP_ID_TEST3,
    META_ES_CONFIG_ID: process.env.REACT_APP_META_ES_CONFIG_ID_TEST3,
    WEB_SERVICE_CONTACTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CONTACTS_BASE_URI_TEST3,
    WEB_SERVICE_ASSISTANTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_ASSISTANTS_BASE_URI_TEST3,
    WEB_SERVICE_CALLING_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CALLING_BASE_URI_TEST3,
    WEB_SERVICE_CATALOG_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CATALOG_BASE_URI_TEST3,
    WS_MEDIA_SERVER_BASE_URI:
      process.env.REACT_APP_WS_MEDIA_SERVER_BASE_URI_DEV,
    WS_MEDIA_SERVER_TOKEN: process.env.REACT_APP_WS_MEDIA_SERVER_TOKEN_DEV,
    HUBSPOT_URL: process.env.REACT_APP_HUBSPOT_URL_TEST3,
    FUNNEL_TRACKING_BASE_URI:
      process.env.REACT_APP_FUNNEL_TRACKING_BASE_URI_TEST3,
    FUNNEL_TRACKING_API_KEY:
      process.env.REACT_APP_FUNNEL_TRACKING_API_KEY_TEST3,
  },
  production: {
    WEB_SERVICE_BASE_URI: process.env.REACT_APP_WEB_SERVICE_BASE_URI_PROD,
    WEB_SERVICE_BROADCAST_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_BROADCAST_BASE_URI_PROD,
    WEB_SERVICE_ECOMMERCE_URI:
      process.env.REACT_APP_WEB_SERVICE_ECOMMERCE_URI_PROD,
    META_APP_ID: process.env.REACT_APP_META_APP_ID_PROD,
    META_ES_CONFIG_ID: process.env.REACT_APP_META_ES_CONFIG_ID_PROD,
    WEB_SERVICE_CONTACTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CONTACTS_BASE_URI_PROD,
    WEB_SERVICE_ASSISTANTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_ASSISTANTS_BASE_URI_PROD,
    WEB_SERVICE_CALLING_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CALLING_BASE_URI_PROD,
    WEB_SERVICE_CATALOG_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CATALOG_BASE_URI_PROD,
    WEB_SERVICE_MERCADOPAGO_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_MERCADOPAGO_BASE_URI_PROD,
    WS_MEDIA_SERVER_BASE_URI:
      process.env.REACT_APP_WS_MEDIA_SERVER_BASE_URI_PROD,
    WS_MEDIA_SERVER_TOKEN: process.env.REACT_APP_WS_MEDIA_SERVER_TOKEN_PROD,
    HUBSPOT_URL: process.env.REACT_APP_HUBSPOT_URL_PROD,
    FUNNEL_TRACKING_BASE_URI:
      process.env.REACT_APP_FUNNEL_TRACKING_BASE_URI_PROD,
    FUNNEL_TRACKING_API_KEY: process.env.REACT_APP_FUNNEL_TRACKING_API_KEY_PROD,
  },
  beta: {
    WEB_SERVICE_BASE_URI: process.env.REACT_APP_WEB_SERVICE_BASE_URI_PROD,
    WEB_SERVICE_BROADCAST_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_BROADCAST_BASE_URI_PROD,
    WEB_SERVICE_ECOMMERCE_URI:
      process.env.REACT_APP_WEB_SERVICE_ECOMMERCE_URI_PROD,
    META_APP_ID: process.env.REACT_APP_META_APP_ID_TEST,
    META_ES_CONFIG_ID: process.env.REACT_APP_META_ES_CONFIG_ID_TEST,
    WEB_SERVICE_CONTACTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CONTACTS_BASE_URI_PROD,
    WEB_SERVICE_ASSISTANTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_ASSISTANTS_BASE_URI_PROD,
    WEB_SERVICE_CALLING_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CALLING_BASE_URI_PROD,
    WEB_SERVICE_CATALOG_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CATALOG_BASE_URI_PROD,
    WEB_SERVICE_MERCADOPAGO_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_MERCADOPAGO_BASE_URI_PROD,
    WS_MEDIA_SERVER_BASE_URI:
      process.env.REACT_APP_WS_MEDIA_SERVER_BASE_URI_PROD,
    WS_MEDIA_SERVER_TOKEN: process.env.REACT_APP_WS_MEDIA_SERVER_TOKEN_PROD,
    HUBSPOT_URL: process.env.REACT_APP_HUBSPOT_URL_BETA,
    FUNNEL_TRACKING_BASE_URI:
      process.env.REACT_APP_FUNNEL_TRACKING_BASE_URI_PROD,
    FUNNEL_TRACKING_API_KEY: process.env.REACT_APP_FUNNEL_TRACKING_API_KEY_PROD,
  },
  local: {
    WEB_SERVICE_BASE_URI: process.env.REACT_APP_WEB_SERVICE_BASE_URI_LOCAL,
    WEB_SERVICE_BROADCAST_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_BROADCAST_BASE_URI_LOCAL,
    META_APP_ID: process.env.REACT_APP_META_APP_ID_DEV,
    META_ES_CONFIG_ID: process.env.REACT_APP_META_ES_CONFIG_ID_DEV,
    WEB_SERVICE_ECOMMERCE_URI:
      process.env.REACT_APP_WEB_SERVICE_ECOMMERCE_URI_LOCAL,
    WEB_SERVICE_CONTACTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CONTACTS_BASE_URI_LOCAL,
    WEB_SERVICE_ASSISTANTS_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_ASSISTANTS_BASE_URI_LOCAL,
    WEB_SERVICE_CALLING_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CALLING_BASE_URI_LOCAL,
    WEB_SERVICE_CATALOG_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_CATALOG_BASE_URI_LOCAL,
    WEB_SERVICE_MERCADOPAGO_BASE_URI:
      process.env.REACT_APP_WEB_SERVICE_MERCADOPAGO_BASE_URI_LOCAL,
    WS_MEDIA_SERVER_BASE_URI:
      process.env.REACT_APP_WS_MEDIA_SERVER_BASE_URI_DEV,
    WS_MEDIA_SERVER_TOKEN: process.env.REACT_APP_WS_MEDIA_SERVER_TOKEN_DEV,
    HUBSPOT_URL: process.env.REACT_APP_HUBSPOT_URL_DEV,
    FUNNEL_TRACKING_BASE_URI:
      process.env.REACT_APP_FUNNEL_TRACKING_BASE_URI_LOCAL,
    FUNNEL_TRACKING_API_KEY:
      process.env.REACT_APP_FUNNEL_TRACKING_API_KEY_LOCAL,
  },
}[APP_ENV] as {
  WEB_SERVICE_BASE_URI: string;
  WEB_SERVICE_BROADCAST_BASE_URI: string;
  WEB_SERVICE_ECOMMERCE_URI: string;
  META_APP_ID: string;
  META_ES_CONFIG_ID: string;
  WEB_SERVICE_CONTACTS_BASE_URI: string;
  WEB_SERVICE_ASSISTANTS_BASE_URI: string;
  WEB_SERVICE_CALLING_BASE_URI: string;
  WEB_SERVICE_CATALOG_BASE_URI: string;
  WEB_SERVICE_MERCADOPAGO_BASE_URI: string;
  WS_MEDIA_SERVER_BASE_URI: string;
  WS_MEDIA_SERVER_TOKEN: string;
  HUBSPOT_URL: string;
  FUNNEL_TRACKING_BASE_URI: string;
  FUNNEL_TRACKING_API_KEY: string;
};

const env = Object.freeze({
  ...ENV,
  APP_ENV,
  NODE_ENV: process.env.NODE_ENV,
  VERSION: process.env.REACT_APP_VERSION,
  WEB_SOCKET_BASE_URI: ENV.WEB_SERVICE_BASE_URI,
  SERVICE_MOCK:
    process.env.REACT_APP_WEB_SERVICE_MOCK === 'true' &&
    process.env.NODE_ENV === 'development',
});

declare global {
  export interface Window {
    $env: typeof env;
    version: string;
    spawnNotification: (
      title: string,
      options: NotificationOptions
    ) => Promise<Notification>;
  }
}

Object.defineProperty(window, '$env', {
  value: env,
  configurable: true,
  writable: false,
});

Object.defineProperty(window, 'version', {
  value: process.env.REACT_APP_VERSION,
  configurable: true,
});

export default env;
